import { find, map, some, uniq } from "lodash-es";

export const tuplesToOptions = (tuples) => {
  return tuples.map((t) => {
    return { label: t[0], value: t[1] };
  });
};
// Utility Functions
const policyCoversCptCode = (policy, code) => some(policy?.policy_coverages, (cov) => cov.cpt_code?.id === code.id);
export const findPolicyForCptCode = (group, code) => find(group?.policies, (pol) => policyCoversCptCode(pol, code));
export const cptSettingsForPayor = (payor, code) => payor?.payor_cpt_codes_settings.filter((c) => c.cpt_code_id === code.id) ?? [];
export const cptRequiresPaForPayor = (payor, code) => some(cptSettingsForPayor(payor, code), { requires_pa: true });
export const cptRequiresGCForPayor = (payor, code) => some(cptSettingsForPayor(payor, code), (c) => c.gc_requirement !== null);
export const icdCodesForPolicyCoverage = (policy) => uniq(policy?.policy_coverages.map((c) => c.icd10_code?.code));
export const icdCodesForPayorGroupCoverage = (group) => uniq(map(group?.payor_group_coverages, (c) => c.icd10_code?.code));
